import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../../hooks/axiosInstance";

export default function CheckoutOrders() {
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [order, setOrders] = useState([]);
    const [pagination, setPagination] = useState({});
    const [filter, setFilter] = useState("");
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const orderResponse = await axiosInstance.get("/user/check_out/get_checkout_orders", {
                    params: {
                        page,
                        filter,
                    },
                });

                const fetchedOrders = orderResponse.data.data.orders.data;

                // Group orders by order_code and sum total_price and quantity
                const groupedOrders = fetchedOrders.reduce((acc, order) => {
                    const key = order.order_code; // Unique key based on order_code
                    if (!acc[key]) {
                        acc[key] = {
                            ...order,
                            sum_total_price: 0, // Initialize sum_total_price
                            sum_quantity: 0,
                        };
                    }
                    // Sum total_price and quantity for all payment types
                    acc[key].sum_total_price += order.total_price;
                    acc[key].sum_quantity += order.quantity;

                    return acc;
                }, {});

                // Convert groupedOrders object back to array
                const ordersArray = Object.values(groupedOrders);

                setOrders(ordersArray);
                setPagination(orderResponse.data.data.orders);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false); // Hide loader after fetching data
            }
        };

        fetchOrders();
    }, [page, filter, refreshKey]);

    // Filter orders to show only the first instance of each unique order_code
    const uniqueOrders = Array.from(new Map(order.map(order => [order.order_code, order])).values());

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= pagination.last_page) {
            setPage(newPage);
        }
    };
    const handleRefresh = () => {
        setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
    };

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
    };

    useEffect(() => { }, [refreshKey]);


    const handleDownloadWaybill = async (orderCode) => {
        try {
            // Send request to backend to generate PDF
            const response = await axiosInstance.post("/user/check_out/generate-waybill", { orderCode }, {
                responseType: 'blob' // Ensure the response is treated as binary data (PDF)
            });

            // Create a URL for the PDF blob
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `waybill_${orderCode}.pdf`; // Set the default file name
            link.click(); // Trigger the download
        } catch (error) {
            console.error('Error downloading the waybill:', error);
        }
    };

    return (
        <>

            <div className="row" id="contactList">
                <div className="col-lg-12">
                    <div className="card">

                        <div className="card-body border border-dashed border-end-0 border-start-0">
                            <div className="d-flex justify-content-between">
                                <div className="col-xl-4 col-md-6">
                                    <div className="search-box">
                                        <input
                                            type="text"
                                            className="form-control search"
                                            placeholder="Search product..."
                                            value={filter}
                                            onChange={handleFilterChange}
                                        />
                                        <i className="ri-search-line search-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body">
                            <div className="table-responsive table-card">
                                <table
                                    className="table align-middle table-nowrap table table-striped table-borderless table-hover"
                                    id="customerTable"
                                >
                                    <thead className="table-light text-muted">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th>Product</th>
                                            <th>Category</th>
                                            <th>Sub category</th>
                                            {/* <th>Warehouse</th> */}
                                            <th>Quantity</th>
                                            <th>Order Code</th>
                                            <td>Action</td>
                                        </tr>
                                    </thead>
                                    {/* <!--end thead--> */}
                                    <tbody className="list form-check-all">
                                        {uniqueOrders.length > 0 ? (
                                            uniqueOrders.map((ord, index) => (
                                                <tr key={ord.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{ord.order.product.product_name}</td>
                                                    <td>{ord.order.category.name}</td>
                                                    <td>{ord.order.subcategory.name}</td>
                                                    <td>{ord.sum_quantity || ord.quantity}</td>
                                                    <td>{ord.order_code}</td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <i className="mdi mdi-apps"></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <Link
                                                                        className="dropdown-item"
                                                                        onClick={() => handleDownloadWaybill(ord.order_code)}
                                                                    >
                                                                        <i className="mdi mdi-pencil me-2 text-success"></i>{" "}
                                                                        Print Waybill
                                                                    </Link>
                                                                </li>

                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center">No orders found.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {/* <!--end table--> */}
                                <div className="d-flex mt-5 mb-5 flex-wrap">
                                    <div className="pagination-wrap hstack gap-2 mx-auto">
                                        <ul className="pagination">
                                            <li
                                                className={`page-item ${pagination.current_page === 1 ? "disabled" : ""
                                                    }`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() =>
                                                        handlePageChange(pagination.current_page - 1)
                                                    }
                                                    disabled={pagination.current_page === 1}
                                                >
                                                    Previous
                                                </button>
                                            </li>
                                            {Array.from(
                                                { length: pagination.last_page },
                                                (_, index) => index + 1
                                            ).map((pageNumber) => (
                                                <li
                                                    key={pageNumber}
                                                    className={`page-item ${pageNumber === pagination.current_page
                                                        ? "active"
                                                        : ""
                                                        }`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(pageNumber)}
                                                    >
                                                        {pageNumber}
                                                    </button>
                                                </li>
                                            ))}
                                            <li
                                                className={`page-item ${pagination.current_page === pagination.last_page
                                                    ? "disabled"
                                                    : ""
                                                    }`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() =>
                                                        handlePageChange(pagination.current_page + 1)
                                                    }
                                                    disabled={
                                                        pagination.current_page === pagination.last_page
                                                    }
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}
